import { useEffect, useState } from 'react'

// Matches Tailwind's `lg` breakpoint (1024px). Mobile = below it.
const MOBILE_QUERY = '(max-width: 1023px)'

function detect() {
  if (typeof window === 'undefined') return false
  return window.matchMedia ? window.matchMedia(MOBILE_QUERY).matches : false
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(detect)

  useEffect(() => {
    if (!window.matchMedia) return
    const mq = window.matchMedia(MOBILE_QUERY)
    const handler = (e) => setIsMobile(e.matches)

    if (mq.addEventListener) {
      mq.addEventListener('change', handler)
      return () => mq.removeEventListener('change', handler)
    }
    mq.addListener(handler)
    return () => mq.removeListener(handler)
  }, [])

  return isMobile
}
